const MarketMethods = {
    viewMethods: [
      'get_sales_by_nft_contract_id',
      'get_sale',
      'get_supply_sales',
      'storage_paid',
      'storage_amount',
      'get_supply_by_owner_id',
      'get_sales_by_owner_id'
    ],
    changeMethods: ['offer', 'storage_deposit'],
  };
  
  export default MarketMethods;